/**
 * Reducer for obtaining all flights
 */
import Constants from '../constants/AllFlightsConstants';
import { fromJS, List as IList } from 'immutable';

const initialState = null;

/**
 * ## auth function
 * @param {Object} state - initialState
 * @param {Object} action - type and data
 */
export default function allFlights (state = initialState, action = null) {
  switch (action.type) {
    /**
     * ### REQUESTS (start)
     */
    case Constants.ALL_FLIGHTS_REQUEST:
      return null;

    /**
     * ### SUCCESS (request ended with success)
     */
    case Constants.ALL_FLIGHTS_SUCCESS:
      return fromJS(action.data);

    /**
     * ### FAILURE (request ended with error)
     */
    case Constants.ALL_FLIGHTS_FAILURE:
      return IList();

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/AllFlightsReducer.js